<ng-template vdrDialogTitle>
  <div class="title-row">
    <span>{{ 'ticket.create-new' | translate }}</span>
  </div>
</ng-template>
<form [formGroup]="detailForm">
  <vdr-form-field [label]='"ticket.subject" | translate' for="subject">
    <input type="text" formControlName="subject" />
  </vdr-form-field>
  <vdr-form-field
    *ngIf="isFromFloating"
    class="mt-2"
    [label]='"ticket.location" | translate'
    for="url"
  >
    <input type="text" formControlName="url" />
  </vdr-form-field>
  <vdr-form-field
    class="mt-2"
    [label]='"common.description"| translate'
    for="description"
  >
    <custom-rich-text-editor
      formControlName="description"
      style="width: 100%"
    ></custom-rich-text-editor>
  </vdr-form-field>
  <div class="form-grid mt-2">
    <vdr-form-field [label]="'ticket.requester'| translate" for="requester">
      <ng-select
        appendTo="body"
        [trackByFn]="trackByFn"
        [items]="adminList$|async"
        formControlName="requester"
        bindValue="id"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ renderMe(item) }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ renderMe(item) }}
        </ng-template>
      </ng-select>
    </vdr-form-field>
    <vdr-form-field [label]="'ticket.assignee' |translate" for="assignee">
      <ng-select
        [trackByFn]="trackByFn"
        formControlName="assignee"
        appendTo="body"
        [items]="adminList$|async"
        bindValue="id"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          {{ renderMe(item) }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ renderMe(item) }}
        </ng-template>
      </ng-select>
    </vdr-form-field>
    <vdr-form-field [label]="'ticket.priority' | translate" for="priority">
      <ng-select
        formControlName="priority"
        [items]="ticketPriorities"
        appendTo="body"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ ('ticket.' + item) | translate }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ ('ticket.' + item) | translate }}
        </ng-template>
      </ng-select>
    </vdr-form-field>
    <vdr-form-field [label]="'ticket.due-date'| translate" for="dueDate">
      <vdr-datetime-picker formControlName="dueDate"></vdr-datetime-picker>
    </vdr-form-field>
  </div>
</form>
<button
  [disabled]="detailForm.invalid"
  class="button primary mt-2"
  (click)="submit()"
>
  {{ 'ticket.submit' | translate}}
</button>
